<script lang="ts" setup>
</script>

<template>
  <v-container>
    <div class="d-flex flex-column align-center justify-center" style="height: 60vh; gap: 2rem;">
      <v-icon size="100" icon="mdi-routes"></v-icon>
      <h5>
        {{ $t('route_not_found') }}
      </h5>
      <v-btn prepend-icon="mdi-home-outline" :text="$t('back_to_home')" to="/"></v-btn>
    </div>
  </v-container>
</template>